import { useTranslation } from 'react-i18next';

import { useOrderFormStore } from 'stores/orderForm/orderForm';
import { formatCurrency } from 'support/helpers/currency/currency';

import { HeaderSectionDivider } from 'components/OrderFormPageLayout/components/Header/components/HeaderSection';
import { ProgressBar } from 'components/ProgressBar/ProgressBar';

export const OrderFormMinAmountProgressBar = () => {
  const { t } = useTranslation();
  const { subtotal, minAmount, currency } = useOrderFormStore((state) => ({
    subtotal: state.subtotal,
    minAmount: state.minAmount,
    currency: state.currency,
  }));
  if (!minAmount) {
    return null;
  }

  return (
    <>
      <div className="flex items-center gap-3">
        <ProgressBar showLabel={false} progress={(subtotal / minAmount) * 100} barClassName="w-24" />

        <span className="shrink-0 text-sm text-gray-700">
          {t('orderForms:form.minAmountProgressBar.label', {
            minAmount: formatCurrency(minAmount, currency),
          })}
        </span>
      </div>
      <HeaderSectionDivider />
    </>
  );
};
